import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Form, Select } from "antd";

import { FILTER_KEYS, SORTER_KEYS } from "constants/table";

const { useWatch } = Form;

const FormItemSorters = ({
  form,
  sortByOptions,
  sortOrderOptions = [
    { label: "Ascending", value: "asc" },
    { label: "Descending", value: "desc" },
  ],
}) => {
  let sortByOptionMap = {};
  sortByOptions.forEach((option) =>
    Object.assign(sortByOptionMap, { [option.value]: option })
  );

  const sorterValues = useWatch(FILTER_KEYS.SORTERS, form);
  const selectedSortByValues =
    sorterValues
      ?.map((sorter) => sorter?.[SORTER_KEYS.SORT_BY])
      .filter((sorter) => !!sorter) ?? [];

  const availableSortByOptions =
    selectedSortByValues.length > 0
      ? sortByOptions.filter(
          (option) => !selectedSortByValues.includes(option.value)
        )
      : sortByOptions;

  return (
    <>
      <Form.List name={FILTER_KEYS.SORTERS}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <>
                <Flex key={key} gap="small" align="baseline">
                  <Form.Item
                    {...restField}
                    name={[name, SORTER_KEYS.SORT_BY]}
                    style={{ width: "50%" }}
                  >
                    <Select
                      options={[
                        ...availableSortByOptions,
                        sortByOptionMap[
                          form.getFieldValue([
                            FILTER_KEYS.SORTERS,
                            name,
                            SORTER_KEYS.SORT_BY,
                          ])
                        ] ?? null,
                      ].filter((option) => option !== null)}
                      placeholder="Sort By"
                    />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, SORTER_KEYS.SORT_ORDER]}
                    style={{ width: "45%" }}
                  >
                    <Select
                      options={sortOrderOptions}
                      placeholder="Sort Order"
                    />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Flex>
              </>
            ))}
            {availableSortByOptions.length > 0 &&
              fields.length < sortByOptions.length && (
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  Add Sorter
                </Button>
              )}
          </>
        )}
      </Form.List>
    </>
  );
};

export default FormItemSorters;
